module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraLight.86a2f13e.ttf";